import React from 'react';
import './kick-start.css';

const m_learning = () => {
    return (
        <div className="m_learning__wrap">
            <div className="m_learning container">
                <h3 className="m_learning--title">Learn Essential Skills to Kick-start Your Career</h3>
                <p className="m_learning--text inner_pages--text">Data Science skills are in ever-increasing demand. Whether you are a data science beginner, a software engineer looking to augment skills, or even a business professional looking beyond the hype, our Kick-start track is for you.</p>
                <p className="m_learning--text inner_pages--text">The Data Science Kick-start track offers many introductory level talks, tutorials, and workshops to get you started. Our expert speakers and presenters offer world-class instruction, and give you invaluable insights to help you learn what matters most. We cover the most important tools, topic, and techniques in use to ensure you hit the ground running.</p>
            </div>
        </div>
    );
};

export default m_learning;